module.exports = __webpack_public_path__ + "static/media/E-BIKE.07d81f38.png";